import React from 'react'
import { common } from '../constants/constants'
import Large from '../Theme/Typography/Large'

export default function NoMoreToLoad({pl={base:"0",md:"0"},lineHeight={base:'24px',md:'34px'},className}) {
  return (
    <>
    <Large pl={pl} fontSize={{base:"12px",md:"14px"}} lineHeight={lineHeight} className={className} fontWeight='400' color="color.primary" py="2">
        {common.NO_MORE_ITEM_TO_LOAD}
    </Large>
    </>
  )
}
